/* Stellan theme scripts */
(function () {
  'use strict';

  var S = window.Stellan || {};
  var routes = S.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || S.moneyFormat || '${{amount}}';
    function fmt(num, decimals, thousands, decimal) {
      decimals = decimals == null ? 2 : decimals;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var n = (num / 100).toFixed(decimals);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  function lockScroll(lock) { document.documentElement.style.overflow = lock ? 'hidden' : ''; }

  /* ---------- mobile menu ---------- */
  function initMenu() {
    var menu = $('#MobileMenu');
    if (!menu) return;
    var opener = $('[data-menu-open]');
    function set(open) {
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      lockScroll(open);
    }
    if (opener) opener.addEventListener('click', function () { set(true); });
    $$('[data-menu-close]', menu).forEach(function (el) { el.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* ---------- cart drawer ---------- */
  var drawer;
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll(true);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    lockScroll(false);
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (el.classList.contains('cart-bubble')) el.hidden = cart.item_count === 0;
    });
    if (!drawer) return;
    var body = $('[data-cart-items]', drawer);
    var foot = $('[data-cart-foot]', drawer);
    var sub = $('[data-cart-subtotal]', drawer);
    if (sub) sub.textContent = formatMoney(cart.total_price);
    if (foot) foot.hidden = cart.item_count === 0;
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="drawer__empty"><p>Your cart is empty</p>' +
        '<button type="button" class="btn btn--ghost" data-cart-close>Continue shopping</button></div>';
      $$('[data-cart-close]', body).forEach(function (el) { el.addEventListener('click', closeDrawer); });
      return;
    }

    var html = '<ul class="cart-lines" role="list">';
    cart.items.forEach(function (item) {
      var img = item.image || (item.featured_image && item.featured_image.url) || '';
      if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<span class="line__variant">' + esc(item.variant_title) + '</span>' : '';
      var props = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          var v = item.properties[k];
          if (k.charAt(0) !== '_' && v) props += '<span class="line__variant">' + esc(k) + ': ' + esc(v) + '</span>';
        });
      }
      var isGift = !!(item.properties && item.properties._gift);
      var compare = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
      var priceHtml = item.final_line_price === 0 ? '<strong class="line__free">FREE</strong>' : '<strong>' + formatMoney(item.final_line_price) + '</strong>';
      var giftTag = isGift ? '<span class="line__gift">' + esc((S.gift && S.gift.label) || 'FREE GIFT') + '</span>' : '';
      html += '<li class="line" data-key="' + esc(item.key) + '">' +
        '<a class="line__img" href="' + esc(item.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="76" height="76">' : '') + '</a>' +
        '<div class="line__info"><a class="line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant + props + giftTag +
        (isGift ? '<span class="line__variant">Qty ' + item.quantity + '</span>' :
        '<div class="qty"><button type="button" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button><span>' + item.quantity + '</span>' +
        '<button type="button" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button></div>') + '</div>' +
        '<div class="line__price">' + compare + priceHtml +
        (isGift ? '' : '<button type="button" class="line__remove" data-qty="0">Remove</button>') + '</div>' +
        '</li>';
    });
    html += '</ul>';
    body.innerHTML = html;

    $$('[data-qty]', body).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.closest('[data-key]');
        changeLine(line.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty'), 10));
      });
    });
  }

  function getCart() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* Keep one free gift per kit, in the kit's color */
  function giftPlan(cart) {
    var g = S.gift;
    if (!g || !g.kit || !g.variants) return null;
    var want = {}, have = {}, keys = {};
    cart.items.forEach(function (it) {
      var color = it.variant_options && it.variant_options[0];
      if (it.handle === g.kit) {
        var c = null;
        (it.options_with_values || []).forEach(function (o) { if (/colou?r/i.test(o.name)) c = o.value; });
        c = c || color;
        want[c] = (want[c] || 0) + it.quantity;
      } else if (it.handle === g.product && it.properties && it.properties._gift) {
        have[color] = (have[color] || 0) + it.quantity;
        keys[color] = it.key;
      }
    });
    var updates = {}, adds = [], dirty = false;
    Object.keys(have).forEach(function (c) {
      var w = want[c] || 0;
      if (w !== have[c]) { updates[keys[c]] = w; dirty = true; }
    });
    Object.keys(want).forEach(function (c) {
      if (!have[c] && g.variants[c]) { adds.push({ id: g.variants[c], quantity: want[c], properties: { _gift: 'kit' } }); dirty = true; }
    });
    return dirty ? { updates: updates, adds: adds } : null;
  }

  function syncGifts(cart) {
    var plan = giftPlan(cart);
    if (!plan) return Promise.resolve(cart);
    var p = Promise.resolve();
    if (Object.keys(plan.updates).length) {
      p = p.then(function () {
        return fetch(routes.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: plan.updates }) });
      });
    }
    if (plan.adds.length) {
      p = p.then(function () {
        return fetch(routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: plan.adds }) });
      });
    }
    return p.then(getCart);
  }

  function fetchCart() {
    return getCart()
      .then(syncGifts)
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, qty) {
    if (drawer) drawer.classList.add('is-busy');
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    })
      .then(function (r) { return r.json(); })
      .then(syncGifts)
      .then(function (cart) { renderCart(cart); })
      .finally(function () { if (drawer) drawer.classList.remove('is-busy'); });
  }

  function initDrawer() {
    drawer = $('#CartDrawer');
    if (!drawer || S.cartType === 'page') return;
    $$('[data-cart-close]', drawer).forEach(function (el) { el.addEventListener('click', closeDrawer); });
    $$('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(openDrawer);
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    document.addEventListener('cart:refresh', function () { fetchCart(); });
    fetchCart();
  }

  /* ---------- product form ---------- */
  function initProductForms() {
    $$('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (S.cartType === 'page') return;
        e.preventDefault();
        var btn = $('[data-atc]', form);
        var err = $('[data-form-error]', form);
        if (btn) btn.classList.add('is-loading');
        if (err) err.hidden = true;
        fetch(routes.cartAdd + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok || res.data.status) {
              if (err) { err.textContent = res.data.description || res.data.message || 'Something went wrong. Please try again.'; err.hidden = false; }
              return;
            }
            document.dispatchEvent(new CustomEvent('cart:added', { detail: res.data }));
            return fetchCart().then(openDrawer);
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    });
  }

  /* ---------- gallery ---------- */
  function initGallery(section) {
    var gallery = $('[data-gallery]', section);
    if (!gallery) return null;
    var track = $('[data-gallery-track]', gallery);
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-thumb]', gallery);
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var active = thumbs[i];
      if (active && active.parentNode) {
        var p = active.parentNode;
        var left = active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2;
        p.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    function goTo(i, instant) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      setActive(i);
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setActive(i);
      }, 60);
    }, { passive: true });
    var prev = $('[data-gallery-prev]', gallery);
    var next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    thumbs.forEach(function (th) {
      th.addEventListener('click', function () { goTo(parseInt(th.getAttribute('data-thumb'), 10)); });
    });

    return {
      goToMedia: function (mediaId) {
        if (!mediaId) return;
        for (var k = 0; k < slides.length; k++) {
          if (String(slides[k].getAttribute('data-media-id')) === String(mediaId)) { goTo(k); return; }
        }
      }
    };
  }

  /* ---------- variant picker ---------- */
  function initProductSection(section) {
    var gallery = initGallery(section);
    section._gallery = gallery;
    initOffers(section);
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var picker = $('[data-variant-picker]', section);
    var idInput = $('[data-variant-id]', section);
    if (!picker || !idInput) return;

    function selected() {
      var vals = [];
      product.options.forEach(function (_, i) {
        var checked = $('input[data-opt-index="' + i + '"]:checked', picker);
        vals[i] = checked ? checked.value : null;
      });
      return vals;
    }

    function update() {
      var vals = selected();
      var variant = product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      })[0];

      vals.forEach(function (v, i) {
        var lbl = $('[data-opt-selected="' + i + '"]', picker);
        if (lbl) lbl.textContent = v;
      });

      var btn = $('[data-atc]', section);
      var label = $('[data-atc-label]', section);
      if (!label.getAttribute('data-default')) label.setAttribute('data-default', label.textContent);

      if (!variant) {
        if (btn) btn.disabled = true;
        label.textContent = 'Unavailable';
        return;
      }

      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (btn) btn.disabled = !variant.available;
      label.textContent = variant.available ? label.getAttribute('data-default') : 'Sold out';

      var price = $('[data-price]', section);
      var compare = $('[data-compare]', section);
      var pill = $('[data-sale-pill]', section);
      var pct = $('[data-sale-pct]', section);
      var badge = $('[data-sale-badge]', section);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var off = onSale ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
      if (price) price.textContent = formatMoney(variant.price);
      if (compare) { compare.hidden = !onSale; if (onSale) compare.textContent = formatMoney(variant.compare_at_price); }
      if (pill) pill.hidden = !onSale;
      if (pct) pct.textContent = off;
      if (badge) { badge.hidden = !onSale; badge.textContent = 'Save ' + off + '%'; }

      if (gallery && variant.media_id) gallery.goToMedia(variant.media_id);

      if (document.body.classList.contains('template-product') && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant, sectionId: section.getAttribute('data-section') } }));
    }

    picker.addEventListener('change', update);
  }

  /* ---------- offer selector ---------- */
  function initOffers(section) {
    var root = $('[data-offers]', section);
    if (!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    var data;
    try { data = JSON.parse($('[data-offers-json]', root).textContent); } catch (e) { return; }
    var cards = $$('[data-offer]', root);
    var qty = {};
    cards.forEach(function (c) { qty[c.getAttribute('data-offer')] = 1; });
    var atc = $('[data-offers-atc]', root);
    var totalEl = $('[data-atc-total]', root);
    var err = $('[data-form-error]', root);
    var colorLabel = $('[data-color-label]', root);
    var gallery = section._gallery;

    function sel() { var r = $('[data-offer-input]:checked', root); return r ? r.value : 'kit'; }
    function color() { var r = $('[data-color-input]:checked', root); return r ? r.value : null; }
    function variantFor(key, c) {
      var opt = data.options[key]; if (!opt) return null;
      var v = opt.variants[c];
      if (!v) { var ks = Object.keys(opt.variants); v = ks.length ? opt.variants[ks[0]] : null; }
      return v;
    }

    function render(jump) {
      var key = sel(), c = color();
      cards.forEach(function (card) {
        var k = card.getAttribute('data-offer');
        var v = variantFor(k, c);
        card.classList.toggle('is-selected', k === key);
        card.classList.toggle('is-unavailable', !!v && !v.available);
        if (!v) return;
        var pr = $('[data-offer-price]', card), cp = $('[data-offer-compare]', card), im = $('[data-offer-img]', card);
        if (pr) pr.textContent = formatMoney(v.price);
        if (cp) { cp.hidden = !(v.compare > v.price); if (v.compare > v.price) cp.textContent = formatMoney(v.compare); }
        if (im && v.image) im.src = v.image;
        var q = $('[data-qty-val]', card); if (q) q.textContent = qty[k];
        var minus = $('[data-qty-step="-1"]', card); if (minus) minus.disabled = qty[k] <= 1;
      });
      if (colorLabel && c) colorLabel.textContent = c;

      var v = variantFor(key, c);
      if (!v) return;
      var total = v.price * qty[key];
      $$('[data-addon]:checked', root).forEach(function (a) { total += parseInt(a.getAttribute('data-addon-price'), 10) || 0; });
      if (totalEl) totalEl.textContent = formatMoney(total);
      if (atc) atc.disabled = !v.available;

      // main price block follows the selected option
      var price = $('[data-price]', section), compare = $('[data-compare]', section);
      var pill = $('[data-sale-pill]', section), pct = $('[data-sale-pct]', section);
      var onSale = v.compare > v.price;
      var off = onSale ? Math.round((v.compare - v.price) * 100 / v.compare) : 0;
      if (price) price.textContent = formatMoney(v.price);
      if (compare) { compare.hidden = !onSale; if (onSale) compare.textContent = formatMoney(v.compare); }
      if (pill) pill.hidden = !onSale;
      if (pct) pct.textContent = off;

      if (jump && gallery) {
        var kv = variantFor('kit', c);
        if (kv && kv.mediaId) gallery.goToMedia(kv.mediaId);
      }
    }

    $$('[data-offer-input]', root).forEach(function (r) { r.addEventListener('change', function () { render(false); }); });
    $$('[data-color-input]', root).forEach(function (r) { r.addEventListener('change', function () { render(true); }); });
    $$('[data-addon]', root).forEach(function (a) { a.addEventListener('change', function () { render(false); }); });
    $$('[data-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var card = b.closest('[data-offer]'); var k = card.getAttribute('data-offer');
        qty[k] = Math.max(1, Math.min(10, qty[k] + parseInt(b.getAttribute('data-qty-step'), 10)));
        render(false);
      });
    });

    if (atc) atc.addEventListener('click', function () {
      var key = sel(), c = color(), v = variantFor(key, c);
      if (!v || !v.available) return;
      var items = [{ id: v.id, quantity: qty[key] }];
      if (key === 'kit' && data.gift && data.gift[c]) {
        items.push({ id: data.gift[c], quantity: qty[key], properties: { _gift: 'kit' } });
      }
      var addons = $$('[data-addon]:checked', root).map(function (a) { return parseInt(a.value, 10); });
      atc.classList.add('is-loading'); if (err) err.hidden = true;
      getCart().then(function (cart) {
        var inCart = cart.items.map(function (i) { return i.variant_id; });
        addons.forEach(function (id) { if (inCart.indexOf(id) === -1) items.push({ id: id, quantity: 1 }); });
        return fetch(routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok || res.data.status) {
            if (err) { err.textContent = res.data.description || res.data.message || 'Something went wrong. Please try again.'; err.hidden = false; }
            return;
          }
          if (S.cartType === 'page') { window.location.href = routes.cart; return; }
          return fetchCart().then(openDrawer);
        })
        .catch(function () { if (err) { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; } })
        .finally(function () { atc.classList.remove('is-loading'); });
    });

    render(false);
  }

  /* ---------- pick color from showcase ---------- */
  function initColorPick() {
    $$('[data-pick-color]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-pick-color');
        var section = $('[data-product-section]');
        if (!section) return;
        var radio = $$('[data-color-input], [data-variant-picker] input[type="radio"]', section).filter(function (r) { return r.value === value; })[0];
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- simple sliders ---------- */
  function initSliders() {
    $$('[data-slider]').forEach(function (slider) {
      var track = $('[data-slider-track]', slider);
      if (!track) return;
      function step() {
        var first = track.firstElementChild;
        return first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      }
      var prev = $('[data-slider-prev]', slider);
      var next = $('[data-slider-next]', slider);
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
    $$('[data-vid-sound]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.parentNode.querySelector('video');
        if (!v) return;
        v.muted = !v.muted;
        if (!v.muted) v.play();
        btn.textContent = v.muted ? '🔇' : '🔊';
      });
    });
  }

  /* ---------- delivery timeline ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  function fmtDate(d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); }
  function range(a, b) { return fmtDate(a) === fmtDate(b) ? fmtDate(a) : fmtDate(a) + ' to ' + fmtDate(b); }
  function initTimeline() {
    $$('[data-timeline]').forEach(function (tl) {
      var now = new Date();
      var n = function (k) { return parseInt(tl.getAttribute(k), 10) || 0; };
      var o = $('[data-tl-ordered]', tl);
      var s = $('[data-tl-ships]', tl);
      var d = $('[data-tl-delivered]', tl);
      if (o) o.textContent = fmtDate(now);
      if (s) s.textContent = range(addBusinessDays(now, n('data-ship-min')), addBusinessDays(now, Math.max(n('data-ship-min'), n('data-ship-max'))));
      if (d) d.textContent = range(addBusinessDays(now, n('data-del-min')), addBusinessDays(now, Math.max(n('data-del-min'), n('data-del-max'))));
    });
  }

  /* ---------- reviews show more ---------- */
  function initReviews() {
    $$('[data-rv-show]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var section = btn.closest('section');
        var hidden = $$('[data-rv-more][hidden]', section);
        var per = parseInt(($('[data-reviews]', section) || {}).getAttribute ? $('[data-reviews]', section).getAttribute('data-per-page') : 6, 10) || 6;
        hidden.slice(0, per).forEach(function (el) { el.hidden = false; });
        if (hidden.length <= per) btn.hidden = true;
      });
    });
  }

  function init() {
    initMenu();
    initDrawer();
    initProductForms();
    $$('[data-product-section]').forEach(initProductSection);
    initColorPick();
    initSliders();
    initTimeline();
    initReviews();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-product-section]');
    if (s) initProductSection(s);
    initSliders();
    initTimeline();
    initReviews();
  });
})();
